//import utility from '@/mixins/utility'

class Cta {

  #data = {}

  #model = {}

  constructor(data={})
  {  
    this.#data = data

    //this.#model = utility.methods.mapModel(data.model, 'library')
  }

  /**
   * Property getters.
   */
  
  get icon()
  {
    return this.#data.icon
  }

  get id()
  {
    return this.#data.id
  }

  get label()
  {
    return this.#data.label
  }

  get url()
  {
    return this.#data.url
  }


  /**
   * Relationships.
   */

  get model()
  {
    return this.#model
  }

  /**
   * Computed properties.
   */
  
}

export default Cta